import {
  ApiNotificationType,
  type EmployeeNotificationListItemDto,
  type LatestEmployeeNotificationDto,
} from '@/modules/Notification/types/api/employeeNotification'
import type {
  AppNotification,
  NotificationType,
} from '@/modules/Notification/types/model'

function resolveNotificationCreatedAt(dto: {
  sentAt: string | null
  createdAt?: string | null
}): string {
  const raw = dto.sentAt ?? dto.createdAt ?? ''
  const trimmed = raw.trim()

  if (!trimmed) {
    return new Date().toISOString()
  }

  return trimmed
}

function apiTypeToUiType(type: ApiNotificationType): NotificationType {
  switch (type) {
    case ApiNotificationType.LetterReceived:
    case ApiNotificationType.LetterForwarded:
      return 'letter'
    case ApiNotificationType.ArticleAssigned:
      return 'announcement'
    case ApiNotificationType.ReminderAssigned:
    case ApiNotificationType.ReminderDue:
      return 'reminder'
    case ApiNotificationType.Manual:
    default:
      return 'manual'
  }
}

export function mapEmployeeNotificationToApp(
  dto: EmployeeNotificationListItemDto
): AppNotification {
  return {
    id: dto.id,
    type: apiTypeToUiType(dto.type),
    title: dto.title,
    subtitle: dto.body,
    body: dto.body,
    createdAt: resolveNotificationCreatedAt(dto),
    isRead: dto.readAt != null,
  }
}

export function mapLatestEmployeeNotificationToApp(
  dto: LatestEmployeeNotificationDto
): AppNotification {
  return {
    id: dto.id,
    type: 'manual',
    title: dto.title,
    subtitle: dto.body,
    body: dto.body,
    createdAt: resolveNotificationCreatedAt(dto),
    isRead: dto.readAt != null,
  }
}
